<script>
	import moment from 'moment';

	export default {
		name: 'AssetDetailsAction',
		props: {
			action: {
				type: Object,
				required: true
			}
		},
		computed: {
			moment() {
				return moment
			},
			employeeInitials() {
				return `${this.action.createdByEmployee.firstName[0]}${this.action.createdByEmployee.lastName[0]}`
			},
			actionText() {
				switch(this.action.action) {
					case "Created":
						return {
							title: "Asset Created"
						}
					case "Assign":
						return {
							title: "Asset Assigned",
							body: this.action.notes
						}
					case "Unassign":
						return {
							title: "Asset Unassigned",
							body: this.action.notes
						}
					case "Retire":
						return {
							title: "Asset Retired",
							body: this.action.notes
						}
					case "Edit":
						return {
							title: "Asset Details Updated",
							body: this.action.notes
						}
					case "Activate":
						return {
							title: "Asset Un-retired",
							body: this.action.notes
						}
					default:
						return {
							title: "Unknown Action",
							body: this.action.notes
						}
				}
			},
			avatarColor() {
				const name = `${this.action.createdByEmployee.firstName} ${this.action.createdByEmployee.lastName}`
				return this.stringToHslColor(name, 30, 80);
			}
		},
		methods: {
			stringToHslColor(str, s, l) {
				let hash = 0;
				for (let i = 0; i < str.length; i++) {
					hash = str.charCodeAt(i) + ((hash << 5) - hash);
				}

				let h = hash % 360;
				return 'hsl('+h+', '+s+'%, '+l+'%)';
			}
		}
	};
</script>

<template>
	<div class="text-xs-left">
		<div class="history-item-container">
			<v-tooltip bottom>
				<template #activator="{ on }">
					<v-avatar :style="{ background: avatarColor, 'min-width': '36px' }" size="36px" v-on="on"><span>{{employeeInitials}}</span></v-avatar>
				</template>
				<span> {{ action.createdByEmployee.firstName }} {{action.createdByEmployee.lastName }} </span>
			</v-tooltip>

			<div class="history-item-details">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<small v-on="on">{{ moment(action.createdDateUTC).from(moment()) }}</small>
					</template>
					<span> {{moment(action.createdDateUTC).format('DD MMM YYYY, HH:mm')}}</span>
				</v-tooltip>

				<div class="history-item-details-content">

					<div class="font-weight-bold">
						<div v-if="action.action === 'Assign'">
							Asset Assigned to {{ action.assignedTo.firstName }} {{ action.assignedTo.lastName }}
						</div>

						<div v-else-if="action.action === 'Unassign'">
							Asset Unassigned from {{ action.unassignedFrom.firstName }} {{ action.unassignedFrom.lastName }}
						</div>

						<div v-else-if="action.action === 'Retire'">
							Asset Retired
						</div>

						<div v-else-if="action.action === 'Created'">
							Asset Created
						</div>

						<div v-else-if="action.action === 'Edit'">
							Asset Details Updated
						</div>

						<div v-else-if="action.action === 'Activate'">
							Asset Un-retired
						</div>

						<div v-else-if="action.action === 'Service'">
							Asset Serviced on the {{moment(action.serviceDate).format("DD MMM YYYY")}}
						</div>

						<div v-else>
							Unknown Asset Action
						</div>
					</div>


					<div v-if="actionText.body">{{ actionText.body }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.history-item-container {
		display: flex;
		gap: 0.5rem;
	}

	.history-item-details {
		background: rgba(0,0,0, 0.05);
		padding: 0.5rem 1rem;
		border-radius: 10px;
	}

</style>